import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { dismissAllToasts } from './useToaster/dismissAllToasts.ts';

const isOrderRoute = (pathname: string) => /^\/order\/[^/]+/.test(pathname);

export const useDismissToastsOnLeaveOrderContext = () => {
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    const prev = prevPathnameRef.current;
    prevPathnameRef.current = pathname;

    if (isOrderRoute(prev) && !isOrderRoute(pathname)) {
      dismissAllToasts();
    }
  }, [pathname]);
};
